import { render, staticRenderFns } from "./CompaniesConfirmation.vue?vue&type=template&id=5465e337&scoped=true&"
import script from "./CompaniesConfirmation.vue?vue&type=script&lang=js&"
export * from "./CompaniesConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesConfirmation.vue?vue&type=style&index=0&id=5465e337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465e337",
  null
  
)

export default component.exports